import {l} from "types/typescriptdefinisjoner_lederplan";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('RevisjonsloggRessurs');

export class RevisjonsloggRessurs {
    static regNavn = "RevisjonsloggRessurs";

    static forInjisering() {
        return [
            regNavn.ng.$resource,
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            RevisjonsloggRessurs
        ]
    }

    private ressurs: ng.resource.IResourceClass<l.EndringshendelseModell>;

    constructor(private $resource: ng.resource.IResourceService, private ressursFeilhåndtering: RessursFeilhåndtering, private gettextCatalog: gettextCatalog) {
        this.ressurs = $resource<l.EndringshendelseModell>("/api/revisjonslogg", {}, {
            finnEndringerIPerioden: {method: "GET", url: "/api/revisjonslogg/finnEndringerIPerioden", isArray: true},
            finnEndringerKnyttetTilMøte: {method: "GET", url: "/api/revisjonslogg/finnEndringerKnyttetTilMoete"},
            finnEndringerKnyttetTilSak: {method: "GET", url: "/api/revisjonslogg/finnEndringerKnyttetTilSak"},
            finnEndringerKnyttetTilGruppe: {method: "GET", url: "/api/revisjonslogg/finnEndringerKnyttetTilGruppe"}
        });
    }


    finnEndringerIPerioden(start: Date, slutt: Date): ng.resource.IResourceArray<l.EndringshendelseModell> {
        debug("finnEndringerIPerioden", start, slutt);
        return this.ressurs["finnEndringerIPerioden"](
            {start: start, slutt: slutt},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne endringshendelser"))
        );
    }

    finnEndringerKnyttetTilMøte(møteId: string, offset: number, antall: number): l.SøkeresultatModell<l.EndringshendelseModell> {
        debug("finnEndringerKnyttetTilMøte", møteId), offset, antall;
        return this.ressurs["finnEndringerKnyttetTilMøte"](
            {id: møteId, offset: offset, antall: antall},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne endringshendelser"))
        );
    }

    finnEndringerKnyttetTilSak(sakId: string, offset: number, antall: number): l.SøkeresultatModell<l.EndringshendelseModell> {
        debug("finnEndringerKnyttetTilSak", sakId, offset, antall);
        return this.ressurs["finnEndringerKnyttetTilSak"](
            {id: sakId, offset: offset, antall: antall},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne endringshendelser"))
        );
    }

    finnEndringerKnyttetTilGruppe(gruppeId: string, offset: number, antall: number): l.SøkeresultatModell<l.EndringshendelseModell> {
        debug("finnEndringerKnyttetTilGruppe", gruppeId, offset, antall);
        return this.ressurs["finnEndringerKnyttetTilGruppe"](
            {id: gruppeId, offset: offset, antall: antall},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne endringshendelser"))
        );
    }

    private håndterFeil(melding: () => string){
        return this.ressursFeilhåndtering.håndterRequestFeil(melding);
    }
}
